import { render, staticRenderFns } from "./PcFeedBack.vue?vue&type=template&id=4c198c6e&scoped=true&"
import script from "./PcFeedBack.vue?vue&type=script&lang=js&"
export * from "./PcFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./PcFeedBack.vue?vue&type=style&index=0&id=4c198c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c198c6e",
  null
  
)

export default component.exports